import axios from 'axios';

export const postApi = async (url, payload) => {
    try {
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error making POST request:', error);
      throw error;
    }
  };